export const getDayDifference = (
  startDateString: string,
  endDateString: string
): number => {
  const startDate = new Date(startDateString);
  const endDate = new Date(endDateString);
  const msInDay = 24 * 60 * 60 * 1000;

  return Math.round(Math.abs(Number(endDate) - Number(startDate)) / msInDay);
};

export const daysCalculator = (
  nextRewardDate: string | null
): number | null => {
  const today = new Date().toUTCString();
  // Need to format the date to be able to use it in the getDayDifference function
  // Format: 'MMDDYYYY'
  if (!nextRewardDate) return null;
  const nextRewardMonth = nextRewardDate.slice(0, 2);
  const nextRewardDay = nextRewardDate.slice(2, 4);
  const nextRewardYear = nextRewardDate.slice(4, 8);
  const formattedNextRewardDate = new Date(
    `${nextRewardMonth}/${nextRewardDay}/${nextRewardYear}`
  ).toUTCString();

  return getDayDifference(today, formattedNextRewardDate);
};
